//let the dom and api consults proccess
setTimeout(function () {
    loadAllTooltips();
},2000)

const displayTooltip = (e) => {
    const trigger = e.target;
    const tooltip = trigger.querySelector("[role=tooltip]");

    const { x, y, width, height } = trigger.getBoundingClientRect();
    const left = Math.floor(x + width / 2 + window.scrollX);
    const top = Math.floor(y + height + window.scrollY);
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;

    tooltip.classList.add("active");
};

const hideTooltip = (e) => {
    const tooltip = e.target.querySelector("[role=tooltip]");
    tooltip.classList.remove("active");
};

function loadAllTooltips() {
    const tooltips = document.querySelectorAll("[data-tooltip]");
    const DELAY = 300;
    let tooltipTimer = null;

    tooltips.forEach((trigger) => {
        let tooltip = document.createElement("div");

        tooltip.setAttribute("role", "tooltip");
        tooltip.setAttribute("inert", true);
        tooltip.innerHTML = trigger.dataset.tooltip;

        trigger.appendChild(tooltip);

        trigger.addEventListener("mouseenter", (e) => {
            clearTimeout(tooltipTimer);

            tooltipTimer = setTimeout(() => {
                displayTooltip(e);
            }, DELAY);
        });

        trigger.addEventListener("mouseleave", (e) => {
            clearTimeout(tooltipTimer);
            hideTooltip(e);
        });
    });
}


function topTooltip(innerHtml, timeout) {
    var tooltip = document.getElementById('top-tooltip');
    if (tooltip) {
        tooltip.remove();
    }
    $('.navigation-menu').append(`<div id="top-tooltip" class="abs-top-tooltip"><div onclick="removeTooltip()" class="top-tooltip">${innerHtml}</div></div>`);

    if (timeout != null) {
        setTimeout(function () {
            var tooltip = document.getElementById('top-tooltip'); //in case it doesnt exist anymore
            if (tooltip) {
                tooltip.classList.add('top-tooltip-remove');
                setTimeout(function () {
                    tooltip.remove();
                }, 400)
            }
        }, timeout)
    }
}
function removeTooltip() {
    var tooltip = document.getElementById('top-tooltip');
    if (tooltip) {
        tooltip.classList.add('top-tooltip-remove');
        setTimeout(function () {
            tooltip.remove();
        },400)
    }
}